/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useTheme, useThemeClassName } from '../../../contexts/ThemeContext';
import StyledButton from '../../buttons/StyledButton';

// import StyledButton from '../../buttons/StyledButton';

import styles from '../../../../styles/displays/steps/step.module.scss';

const propTypes = {
    game: PropTypes.shape({}).isRequired,
    step: PropTypes.shape({}).isRequired,
    notify: PropTypes.func.isRequired,
    notified: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = { notified: false, className: null, children: null };

function WaitStep({ game, notify, notified: initialNotified, className, children }) {
    const { name: theme = null } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const [notified, setNotified] = useState(initialNotified);
    const onNotify = useCallback(() => {
        if (notify !== null) {
            notify('begins');
        }
        setNotified(true);
    }, [setNotified]);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className,
                },
            ])}
        >
            <div className={styles.header}>
                <h1 className={styles.title}>
                    <FormattedMessage
                        defaultMessage="Waiting to start"
                        description="Display title"
                    />
                </h1>
                {theme === 'perfect' ? (
                    <div className={styles.right}>
                        <StyledButton
                            className={styles.button}
                            onClick={onNotify}
                            disabled={notified}
                        >
                            <FormattedMessage
                                defaultMessage="Send a SMS notification"
                                description="Button label"
                            />
                        </StyledButton>
                    </div>
                ) : null}
            </div>
            {game === null ? (
                <p>
                    <FormattedMessage
                        defaultMessage="Select a game to begin."
                        description="Display label"
                    />
                </p>
            ) : (
                <p className={styles.description}>
                    {theme === 'perfect' ? (
                        <FormattedMessage
                            defaultMessage="Press this button to send the SMS reminder."
                            description="Display help text"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="15 minutes before the challenge, an SMS reminder is sent to the registered users. At that point show the code to let the participants in the game."
                            description="Display help text"
                        />
                    )}
                </p>
            )}
            {children !== null ? <div className={styles.preview}>{children}</div> : null}
        </div>
    );
}

WaitStep.propTypes = propTypes;
WaitStep.defaultProps = defaultProps;

export default WaitStep;
